const MONTHS_RU = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
]

const MONTHS_EN = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

/**
 * Форматирование сделано вручную, а не через toLocaleString / Intl:
 * страница рендерится на сервере, и любое расхождение локали между
 * Node и браузером даёт ошибку гидрации на ровном месте.
 *
 * Язык передаём аргументом по той же причине: определять его внутри значило
 * бы читать состояние i18n из чистой функции, которая вызывается и на
 * сервере, и в браузере.
 */
export const formatBlogDate = (isoDate: string, locale = 'ru'): string => {
  const [year, month, day] = isoDate.split('-').map(Number)

  if (!year || !month || !day) return isoDate

  return locale === 'en'
    ? `${MONTHS_EN[month - 1]} ${day}, ${year}`
    : `${day} ${MONTHS_RU[month - 1]} ${year}`
}

/** Разряды разделяем неразрывным узким пробелом в обеих локалях. */
export const formatBlogViews = (views: number, locale = 'ru'): string => {
  return String(views).replace(/\B(?=(\d{3})+(?!\d))/g, locale === 'en' ? ',' : ' ')
}
